import { MenuItem } from '@24i/nxg-sdk-photon/src';
import { useQuery } from 'react-query';
import { useAppStructureData } from '../../../context/AppStructureData';
import { useAppConfigQuery } from '../useAppConfigQuery';
import { getMenuConfigQueryKey } from './utils';
import { QueryResult } from '../types';

export const useMenuQuery = (): QueryResult<MenuItem[]> => {
    const client = useAppStructureData();
    const { appSettings } = useAppConfigQuery();
    const menuId = appSettings?.features?.menus?.main || undefined;

    const { isLoading, data, refetch } = useQuery<MenuItem[]>(
        getMenuConfigQueryKey(menuId),
        () => client.fetchMenu(menuId, appSettings),
        { enabled: Boolean(appSettings) }
    );

    return { isLoading, data, refetch };
};
